import React from 'react';
import { Edit } from 'react-admin';
import { parse } from 'query-string';
import InterventionDomainForm from './InterventionDomainForm';
import MainSkillForm from './MainSkillForm';
import BackButton from 'components/BackButton';

export const InterventionDomainEdit = (props: any) => {
  const { consultantskillset } = parse(props.location.search);
  const redirect = `/consultantskillsets/${consultantskillset}/3`;

  return (
    <Edit {...props} actions={<BackButton goTo={redirect} />} undoable={false}>
      <InterventionDomainForm redirect={redirect} location={props.location} />
    </Edit>
  );
};

export const MainSkillEdit = (props: any) => {
  const { consultantskillset } = parse(props.location.search);
  const redirect = `/consultantskillsets/${consultantskillset}/3`;

  return (
    <Edit {...props} actions={<BackButton goTo={redirect} />} undoable={false}>
      <MainSkillForm redirect={redirect} location={props.location} />
    </Edit>
  );
};
